import { AppLayout } from 'layouts';
import { JoinedCommunities } from 'features/communities';
import { useGetPathToEntityDetail } from '../hooks';

const PageJoinedCommunities = () => {
  const getPathToEntityDetail = useGetPathToEntityDetail();

  return (
    <AppLayout>
      <JoinedCommunities getPathToCommunityDetail={(id) => getPathToEntityDetail(id, { entityType: 'community' })} />
    </AppLayout>
  );
};

export default PageJoinedCommunities;
